var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.show = true}}},[_vm._v("点击")]),_c('Dialag-component',{attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }